import dogTemperature from './png/tip_dog_temperature_fr.png';
import dogTick from './png/tip_dog_tick_fr.png';
import dogStethoscope from './png/tip_dog_stethoscope_fr.png';
import catStethoscope from './png/tip_cat_stethoscope_fr.png';

export default {
  cat: {
    stethoscope: catStethoscope,
  },
  dog: {
    temperature: dogTemperature,
    tick: dogTick,
    stethoscope: dogStethoscope,
  },
};
